import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { SnackBarService } from '../../../../shared/services/snackbar.service';
import { GlobalSpinnerService } from '../../../../shared/components/loader-service/global-spinner.service';
import { MomentDateUtils } from '../../../../shared/utils/moment-date-utils';
import { DateRangeType } from '../../../../shared/domain/date-range-type.enum';
import { DateRangeHolder } from '../../../../shared/domain/date-range-holder.model';
import { OnboardingStageKL } from '../../../../shared/domain/onboarding-stage.enum';
import { TagListKL } from '../../../shared/components/activity/tag-list.enum';
import { User } from '../../../../shared/domain/users/user.model';
import { Publisher } from '../../../../shared/domain/publisher.model';
import { ReportActivityExportRequest } from './report-activity-export-request.model';
import { AdStatsUserActivityService } from '../../../../shared/services/ad-stats-user-activity.service';
import { CsvExportUtils } from '../../../../shared/utils/csv-export-utils';

@Component({
  selector: 'cm-download-report-activity-dialog',
  templateUrl: './download-report-activity-dialog.component.html',
  styles: [`

  `]
})
export class DownloadReportActivityDialogComponent {
  MomentDateUtils = MomentDateUtils;
  TagListKL = TagListKL();
  OnboardingStageKL = OnboardingStageKL();

  requestParams: ReportActivityExportRequest = {
    dateFrom: MomentDateUtils.getDatesFromRange(DateRangeType.THIS_MONTH).dateFrom,
    dateTo: MomentDateUtils.getDatesFromRange(DateRangeType.THIS_MONTH).dateTo,
    stage: [],
    publisherId: [],
    salesRepresentativeEmail: null,
    tag: []
  };

  dateSelector = {
    maxDate: MomentDateUtils.today(),
    allowedDateRangeTypes: [
      DateRangeType.TODAY,
      DateRangeType.YESTERDAY,
      DateRangeType.THIS_WEEK,
      DateRangeType.LAST_7_DAYS,
      DateRangeType.THIS_MONTH,
      DateRangeType.LAST_30_DAYS,
      DateRangeType.LAST_MONTH,
      DateRangeType.LAST_3_MONTHS,
      DateRangeType.LAST_6_MONTHS,
      DateRangeType.THIS_YEAR,
      DateRangeType.LAST_YEAR
    ],
    onDateRangeChanged: (event: DateRangeHolder) => {
      this.requestParams.dateFrom = event.dateFrom;
      this.requestParams.dateTo = event.dateTo;
    },
  };

  constructor(public dialogRef: MatDialogRef<DownloadReportActivityDialogComponent>,
    private gss: GlobalSpinnerService,
    private sbs: SnackBarService,
    private service: AdStatsUserActivityService,
    @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  onPublisherSelectionChange(publishers: Publisher[]) {
    this.requestParams.publisherId = publishers.map(item => item.id);
  }

  onUserSelectionChange(user: User) {
    this.requestParams.salesRepresentativeEmail = user ? user.email : undefined;
  }

  downloadReport() {
    this.gss.showLoader();
    this.service.exportActivityReport(this.requestParams).subscribe(data => {
      this.gss.hideLoader();
      this.sbs.success('Report has been successfully downloaded.');
      CsvExportUtils.exportBlobCsv(data, 'Activity report.csv');
    }, error => {
      this.gss.hideLoader();
      this.sbs.error('Error while downloading report.');
    });
  }

}
